import React from 'react';
import { translate } from 'react-i18next';

import { Form } from 'common/components';
import { DMS_REFERENCE_MAX_LENGTH } from 'lib/assets/dms_reference';

const AssetFormBill = ({
  errors = {},
  handleValueChange = () => {},
  handleFileChange = () => {},
  handleClick = () =>{},
  hiddenFileInput,
  files,
  isSubmitted = false,
  t = () => {},
  values = {},
  name
}) => {
  return (
    <div className="row mt-3 align-items-center bbottom">
      <div className="col-sm-12">
        <h5>
          <b>{t('assets.section.bill')}</b>
        </h5>
        <br />
      </div>
      <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.FieldInput
          error={(isSubmitted && errors.billNumber) || {}}
          name={'billNumber'}
          label={t('assets.fields.billNumber')}
          handleChange={handleValueChange}
          t={t}
          value={values.billNumber}
        />
      </div>
      <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.FieldInput
          error={(isSubmitted && errors.billFolio) || {}}
          name={'billFolio'}
          label={t('assets.fields.billFolio')}
          handleChange={handleValueChange}
          t={t}
          value={values.billFolio}
        />
      </div>
      <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.FieldDate
          error={(isSubmitted && errors.billDate) || {}}
          name={'billDate'}
          label={t('assets.fields.billDate')}
          handleChange={handleValueChange}
          t={t}
          value={values.billDate}
        />
      </div>
      <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.FieldInput
          error={(isSubmitted && errors.billConcept) || {}}
          name={'billConcept'}
          label={t('assets.fields.billConcept')}
          handleChange={handleValueChange}
          t={t}
          value={values.billConcept}
        />
      </div>
      <div className="col-sm-6 col-md-4 col-lg-3">
        {/* Live error, unlike the other fields: errors are recomputed on every
            change (Validated) and only text can fail, so it shows while typing
            and goes away when the field is emptied. */}
        <Form.FieldInput
          error={errors.dmsReference || {}}
          errorPrefix={'asset.dmsReference'}
          name={'dmsReference'}
          label={t('assets.fields.dmsReference')}
          handleChange={handleValueChange}
          t={t}
          value={values.dmsReference}
          maxLength={DMS_REFERENCE_MAX_LENGTH}
        />
      </div>
      <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.FieldInput
          type="number"
          error={(isSubmitted && errors.billConcept) || {}}
          name={'billImport'}
          label={t('assets.fields.billImport')}
          handleChange={handleValueChange}
          t={t}
          value={values.billImport}
        />
      </div>
      <div className="d-flex col-sm-8 col-md-6 col-lg-6" style={{alignItems:'center'}}>
        <button type='button' className="col-g btn btn-info ml-4 mr-4" onClick={handleClick}>
          Subir archivo
        </button>
        <input
          type='file'
          // multiple="multiple"
          id='files'
          value={files}
          onChange={handleFileChange}
          name={'files'}
          ref={hiddenFileInput}
          style={{display: 'none'}}
        />
        {name && name.map(file => <div style={{marginLeft:'3px', marginRight: '3px'}}>{file.name}</div>)}
      </div>
    </div>
  );
};

export default translate()(AssetFormBill);



// WEBPACK FOOTER //
// src/components/assets/form_sections/AssetsFormBill.js